<template>
  <div class="paySuccess" style="padding-top: 0.49rem">
    <div style="height: 4.05rem; margin-bottom: 0.49rem">
      <div class="paySuccess_title">
        <img src="../../assets/img/pay/icon_success_payment@2x.png" alt="" />
        <h3>支付成功</h3>
        <p>我们将尽快为您发货，请保持手机畅通</p>
      </div>
      <div class="shopContent">
        <div class="shopContent_list">
          <div>购买商品：{{ payInfo.title }}</div>
        </div>
        <div class="shopContent_list">
          <div>购买数量：x{{ payInfo.num }}</div>
          <div class="shopContent_list_line"></div>
        </div>
        <div class="shopContent_list">
          <div>订单编号：{{ payInfo.orderId }}</div>
        </div>
        <div class="shopContent_list">
          <div>订单金额：￥{{ payInfo.totalMoney }}</div>
        </div>
      </div>
    </div>
    <div class="btn">
      <van-button type="primary" @click="$router.push({ name: '订单' })"
        >返回</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payInfo: {},
    };
  },
  created() {
    if (this.$route.params.payInfo) {
      this.payInfo = this.$route.params.payInfo;
      sessionStorage.setItem("payInfo", this.$route.params.payInfo);
    } else {
      this.payInfo = sessionStorage.getItem("payInfo");
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem("payInfo");
  },
};
</script>

<style lang='scss'>
.paySuccess {
  .paySuccess_title {
    width: 100%;
    height: 1.91rem;
    background: linear-gradient(0deg, #dbbc8a 0%, #f0d8b1 100%);
    padding-top: 0.27rem;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    img {
      width: 0.58rem;
      height: 0.58rem;
    }
    h3 {
      height: 0.17rem;
      font-size: 0.17rem;
      font-weight: bold;
      color: #93683d;
      margin-top: 0.15rem;
      margin-bottom: 0.08rem;
    }
    p {
      height: 0.12rem;
      font-size: 0.12rem;
      color: #93683d;
    }
  }
  .shopContent {
    width: 3.45rem;
    height: 2.41rem;
    background: url("../../assets/img/pay/bg_white@2x.png") no-repeat;
    background-size: contain;
    position: absolute;
    top: 2.28rem;
    left: 0.15rem;
    padding: 0.18rem 0.22rem 0.21rem 0.22rem;
    .shopContent_list {
      div:nth-child(1) {
        width: 100%;
        height: 0.5rem;
        border-bottom: 0.01rem dashed #f3f1f4;
        line-height: 0.5rem;

        font-size: 0.14rem;
        color: #333333;
      }
    }
  }
  .btn {
    width: 100%;
    height: 0.44rem;
    display: flex;
    justify-content: center;
    .van-button--primary {
      width: 2.72rem;
      height: 0.44rem;
      background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
      border-radius: 0.22rem;
      font-size: 0.16rem;
      font-weight: bold;
      color: #93683d;
      border: none;
    }
  }
}
</style>